module.exports = __webpack_public_path__ + "static/media/icomoon.22233865.eot";